import Phaser from 'phaser';

/** True si le conteneur plateau a une taille utilisable (le refresh scale est fait par l’appelant). */
export function syncPlayCanvasToContainer(_game: Phaser.Game): boolean {
  const container = document.getElementById('game-container');
  return !!(container && container.clientWidth >= 64 && container.clientHeight >= 64);
}

/**
 * Point monde Phaser → coordonnées viewport (clientX/clientY pour position: fixed).
 * Utilise worldView + zoom caméra et le mapping FIT canvas → CSS.
 */
export function worldPointToViewport(
  game: Phaser.Game,
  worldX: number,
  worldY: number
): { x: number; y: number } | null {
  const scene = game.scene.getScene('GameScene');
  const cam = scene?.cameras?.main;
  const canvas = game.canvas;
  if (!cam || !canvas) return null;

  const view = cam.worldView;
  const screenX = (worldX - view.x) * cam.zoom;
  const screenY = (worldY - view.y) * cam.zoom;

  const rect = canvas.getBoundingClientRect();
  const gameW = game.scale.width;
  const gameH = game.scale.height;
  if (gameW <= 0 || gameH <= 0) return null;

  const scaleX = rect.width / gameW;
  const scaleY = rect.height / gameH;

  return {
    x: rect.left + screenX * scaleX,
    y: rect.top + screenY * scaleY,
  };
}
